<span [title]="claimStages[data[fieldName]]">{{claimStages[data[fieldName]]}}</span>
